import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { SystemUser, SystemUserCharacter } from '../../../../domain/user.model';
import { AsideAction, SidenavAction, SidenavSide, SidenavTemplate } from '../../store/aside.action';
import { ScheduleAction } from '../../store/schedule.action';
import { UserAction } from '../../store/user.action';
import { UserState } from '../../store/user.state';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

    characterDropdown = false;
    menuOpen = false;
    subscriptions: Subscription[] = [];
    @ViewChild('buttonCharacter') buttonCharacter: ElementRef;
    @ViewChild('list') list: ElementRef;
    user: SystemUser;

    page = 0;
    pageSize = 4;
    numberOfPages: number;

    constructor(private store: Store,
                private renderer: Renderer2) {
        this.renderer.listen('window', 'click', (e: Event) => {
            if (this.characterDropdown === true && !this.isDescendantOrSame(this.buttonCharacter.nativeElement, e.target)) {
                this.characterDropdown = false;
            }
        });
    }

    private isDescendantOrSame(parent, child) {
        if (parent === child) {
            return true;
        }
        var node = child.parentNode;
        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(UserState.getUser).subscribe(user => {
                this.user = user;
                this.numberOfPages = Math.ceil(((user || {}).characters || []).length / this.pageSize);
            }),
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    openMenu() {
        this.store.dispatch(new AsideAction.Generic(SidenavSide.LEFT, SidenavAction.OPEN, SidenavTemplate.MENU))
            .subscribe(() => this.store.dispatch(new ScheduleAction.GetFlag()));
    }


    openCharacterDropdown() {
        this.characterDropdown = true;
    }

    toggleCharacterDropdown($event: Event) {
        this.characterDropdown = !this.characterDropdown;
        $event.stopPropagation();
    }


    logout() {
        this.store.dispatch(new UserAction.Logout());
    }

    changeCharacter(character: SystemUserCharacter) {
        if (!character.active) {
            this.store.dispatch(new UserAction.ChangeCharacter(character));
        }
    }

    setPage($event: MouseEvent, number: number) {
        this.page = number;
        $event.stopPropagation();
    }
}
